import { render, staticRenderFns } from "./MatrixMenu.vue?vue&type=template&id=bb11a8d6&"
import script from "./MatrixMenu.vue?vue&type=script&lang=js&"
export * from "./MatrixMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports